import { ConvexReactClient } from "convex/react";

/**
 * Singleton Convex client. Passed to ConvexAuthProvider in index.js so that
 * both the React hooks and imperative calls (Zustand stores) share the same
 * authenticated client. ConvexAuthProvider manages auth tokens automatically.
 */
const convex = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL);

let convexAuthState = {
  isLoading: true,
  isAuthenticated: false,
};
const authReadyWaiters = new Set();

function flushAuthReadyWaiters() {
  const settledState = convexAuthState;
  const waiters = Array.from(authReadyWaiters);
  authReadyWaiters.clear();
  waiters.forEach((resolve) => resolve(settledState));
}

/**
 * Imperative Convex calls need to respect auth loading as well, especially
 * after the app wakes up and Convex revalidates the session.
 */
export function reportConvexAuthState(nextState) {
  convexAuthState = {
    isLoading: Boolean(nextState?.isLoading),
    isAuthenticated: Boolean(nextState?.isAuthenticated),
  };

  if (!convexAuthState.isLoading) {
    flushAuthReadyWaiters();
  }
}

/**
 * Feature stores use this before imperative Convex queries/mutations so they
 * don't fire while Convex Auth is still recovering the session.
 */
export function waitForConvexAuthReady() {
  if (!convexAuthState.isLoading) {
    return Promise.resolve(convexAuthState);
  }

  return new Promise((resolve) => {
    authReadyWaiters.add(resolve);
  });
}

export default convex;
